import { useCallback, useState } from "react";

import { CardDataForHash, createCardHash } from "../../../services/bookingPaymentClient";

export type CardTokenState = {
  data: string | null;
  type?: "card_hash" | "card_token";
  loading: boolean;
  error: string | null;
};

export function useCardToken() {
  const [state, setState] = useState<CardTokenState>({
    data: null,
    loading: false,
    error: null,
  });

  const reset = useCallback(() => {
    setState({ data: null, type: undefined, loading: false, error: null });
  }, []);

  const generateToken = useCallback(
    async (cardData: CardDataForHash): Promise<string> => {
      setState((prev) => ({ ...prev, loading: true, error: null }));

      try {
        const token = await createCardHash(cardData);
        setState({ data: token.value, type: token.type, loading: false, error: null });
        return token.value;
      } catch (err: any) {
        const message = err?.message || "Falha ao gerar token do cartão.";
        setState({ data: null, type: undefined, loading: false, error: message });
        throw new Error(message);
      }
    },
    []
  );

  return {
    data: state.data,
    type: state.type,
    loading: state.loading,
    error: state.error,
    createToken: generateToken,
    reset,
  };
}
